import { render, staticRenderFns } from "./problems.vue?vue&type=template&id=0d42913e&scoped=true"
import script from "./problems.vue?vue&type=script&lang=js"
export * from "./problems.vue?vue&type=script&lang=js"
import style0 from "./problems.vue?vue&type=style&index=0&id=0d42913e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d42913e",
  null
  
)

export default component.exports